import React, {useEffect} from 'react'
import styles from "./Handler.module.css";

const Handler = ({ name = '', options = [], handle, setHandle, getCathedra, period, localName, trashCafedra, trashGroup }) => {
  const handleSet = (e) => {

    if ((name == 'Кафедра' && !e) || (name == 'Схема' && !e) || (name == 'Год' && !e)) {
      localStorage.removeItem('grop');
    }

    if (name == 'Факультет' && !e) {
      localStorage.removeItem('kaf');
    }

    if (name == 'Год' && !e) {
      localStorage.removeItem('schema');
      localStorage.removeItem('period');
    }

    if (name == 'Факультет' && !e) {
      trashCafedra();
      trashGroup();
    }

    localStorage.setItem(localName, e);
    setHandle(e);
  }

  useEffect(() => {
    if (name == 'Факультет' && handle) {
      getCathedra(handle);
      trashGroup();
    } else if (name == 'Факультет' && !handle) {
      trashCafedra();
      trashGroup();
    }
  }, [handle])

  const dateAndPeriod = (options, period) => {
    return ([
      options[0],
      options[1],
      options[2],
      options[3],
      options[4],
      // { value: `${period[0]?.term_end.split('.')}_`, name: period[0]?.title },
      options[5],
      options[6],
      options[7],
      options[8],
      options[9]
      // ,
      // { value: `${period[1]?.term_end.split('.')}_`, name: period[1]?.title }
    ])
  }

  const getCutText = (text) => {
    if (text.length > 150) {
      return text.slice(0, 150) + '...'
    } else {
      return text
    }
  }

  return (
    <div className={styles.wrapper_handle}>
      <div className={styles.titleHendler}>{name}:</div>
      <select
        onChange={(e) => handleSet(e.target.value)}
      >
        
        {name && name == 'Факультет' &&
          <><option value={''}>Все</option>
            <>{options && options.map((item) => (<option key={item.idfaculty} value={item.handle || item.idfaculty || localStorage.getItem('fak')} selected={item.idfaculty == handle ? handle : ''}>{getCutText(item.handle || item.faculty)}</option>))}</></>
        }

        {name && name == 'Кафедра' &&
          <><option value={''}>Все</option>
            <>{options && options.map((item) => (<option key={item.idcathedra} value={item.handle || item.idcathedra || localStorage.getItem('kaf')} selected={item.idcathedra == handle ? handle : ''}>{getCutText(item.handle || item.cathedra)}</option>))}</></>
        }

        {name && name == 'Группа' &&
          <><option value={''} disabled selected={!handle}>Выбрать</option>
            <>{options && options.map((item) => (<option key={item.gid} value={item.handle || item.gid || localStorage.getItem('grop')} selected={item.gid == handle ? handle : 0}>{getCutText(item.handle || item.name)}</option>))}</></>
        }

        {name && name == 'Схема' &&
          <><option value={''} disabled selected={!handle}>Выбрать</option>
            <>{options && options.map((item) => (<option key={item.id} value={item.handle || item.id || localStorage.getItem('schema')} selected={item.id == handle ? handle : ''}>{getCutText(item.handle || item.title)}</option>))}</></>
        }

        {
          name && name == 'Месяц' &&
          <><option value={''}>Выбрать</option>
            <>{options && period && dateAndPeriod(options, period).filter(el => el.value && el.name).map((item) => (<option key={item.value} value={item.handle || item.value || localStorage.getItem('period')} selected={item.value == handle ? handle : ''}>{getCutText(item.handle || item.name)}</option>))}</></>
        }

        {
          name && name == 'Год' &&
          <><option value={''} disabled selected={!handle}>Выбрать</option>
            <>{options && options && (([...options].reverse()).slice(0,-1)).map((item) => (<option key={item.name} value={item.handle || item.xp_key || localStorage.getItem('year')} selected={item.xp_key == handle ? handle : ''}>{getCutText(item.handle || item.name)}</option>))}</></>
        }

      </select>
    </div>
  )
}

export default Handler